import { useIsDesktop } from "../lib/useIsDesktop";
import { Guestbook } from "../components/Guestbook";

export function GuestbookPage() {
  const isDesktop = useIsDesktop();
  return (
    <div style={{ padding: isDesktop ? "64px 64px 80px" : "24px 22px 32px" }}>
      <div style={{ maxWidth: 860, margin: "0 auto" }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: "var(--accent)", letterSpacing: 0.6, textTransform: "uppercase" }}>
          Words of encouragement
        </div>
        <h1 style={{ margin: "8px 0 0", fontFamily: "var(--display)", fontSize: isDesktop ? 56 : 36, fontWeight: 400, letterSpacing: -1.4, lineHeight: 1.05 }}>
          Sign the guest book
        </h1>
        <p style={{ marginTop: 16, fontSize: isDesktop ? 17 : 15.5, lineHeight: 1.6, color: "var(--ink-soft)", maxWidth: 620 }}>
          Leave Scott and Baker words of encouragement for the ride.
        </p>
        <div style={{ marginTop: 32 }}>
          <Guestbook isDesktop={isDesktop} />
        </div>
      </div>
    </div>
  );
}
